import axios from 'axios';
import ProfilePassport from '../profilePassport/ProfilePassport.vue';
import CopyIcon from './CopyIcon.vue';

const patternPassword = (val) => {
  const isEmpty = !val;
  const lessThen8Symbols = val.length < 8;
  const noDigits = !/\d/.test(val);
  const hasSpaces = /\s/.test(val);
  const noCapitalLetter = !/[A-Z]/.test(val);
  const noLowercaseLetter = !/[a-z]/.test(val);
  const noSpecialCharacter = !/(?=.*[!@#$%^&*])/.test(val);
  return {
    isEmpty,
    lessThen8Symbols,
    noDigits,
    hasSpaces,
    noCapitalLetter,
    noLowercaseLetter,
    noSpecialCharacter,
  };
};
const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  components: { ProfilePassport, CopyIcon },
  data() {
    return {
      searchAddress: '',
      addresses: [],
      valid: false,
      profile: {},
      sizes: [],
      disabledFields: {
        size_id: false,
        delivery_address: false,
      },
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        email: value => pattern.test(value) || 'Поле E-mail заполнено с ошибками',
        phone: v => (!!v && (!v.length || v.length >= 17))
          || 'Номер телефона заполнен не полностью',
      },
      search: '',
      suggestions: [],
      suggestions_items: [],
      menu2: '',
      cities: [],
      searchCity: '',
      birthday_on_local: '',
      birthday_on: '',
      menu: false,
      activePicker: null,
      date: null,
      submenuBtn: true,
      inviteFriend: false,
      persData: true,
      infoCompany: false,
      changePass: false,
      taxForm: false,
      rulesHtml: '',
      dialogRules: false,
      checkedRules: false,
      pers: '',
      dialogPers: false,
      checkedPers: false,
      showPassword: {
        current: false,
        new: false,
        confirm: false,
      },
      password: {
        current: '',
        new: '',
        confirm: '',
      },
      successfulChange: false,
      changeError: false,
    };
  },
  computed: {
    submenu() {
      return this.$store.state.submenu;
    },
    user() {
      return this.$store.state.user;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  created() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
    this.$store.dispatch('SetSubmenu', '');
  },
  methods: {
    copyText(text) {
      navigator.clipboard.writeText(text);
    },
    /** Определяем возможность редактирования полей */
    setDisabledFields() {
      this.disabledFields.delivery_address = !!this.profile.delivery_address;
      this.disabledFields.size_id = !!this.profile.size_id;
    },
    /** Изменить пароль */
    changePassword() {
      this.$store.getters.axl
        .post('/profiles/api/change-password', {
          currentPassword: this.password.current,
          password: this.password.new,
          passwordCompare: this.password.confirm,
          profile_id: this.user.profile_id,
        })
        .then(() => {
          this.successfulChange = true;
          setTimeout(() => {
            this.successfulChange = false;
          }, 3000);
        })
        .catch(() => {
          this.changeError = true;
          setTimeout(() => {
            this.changeError = false;
          }, 3000);
        })
        .finally(() => {
          this.password.current = '';
          this.password.new = '';
          this.password.confirm = '';
        });
    },
    /** Показать диалог Персональных данных */
    ShowDialogPers(e = null) {
      e && e.preventDefault();
      this.dialogPers = true;
    },
    /** Показать диалог Правил */
    ShowDialogRules(e = null) {
      e && e.preventDefault();
      this.dialogRules = true;
    },
    /** Сохранить аватар */
    SetAvatar(e) {
      const app = this;
      const fr = new FileReader();
      fr.readAsDataURL(e);
      fr.addEventListener('load', () => {
        app.profile.photo = { base64: fr.result };
      });
    },
    /** Удалить аватар */
    RemoveAvatar() {
      this.profile.photo = null;
    },
    onResize() {
      this.small = window.innerWidth <= 1024;
      this.userAva = window.innerWidth <= 1024;
      this.smaller = window.innerWidth <= 599;
      this.searchShow = window.innerWidth <= 599;
      // console.log(this.small ? this.menuMob : false);
    },
    save(date) {
      this.$refs.menu.save(date);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    AutocompleteSelect(item) {
      this.suggestions.forEach((sug) => {
        if (sug.value === item.value) {
          this.address_data = sug.data;
          document.getElementById('ndfl-form-address').focus();
        }
      });
    },
    AutocompleteSearch(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios
        .post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createUser() {
      this.profile = { ...this.user };

      if (this.profile.city) {
        this.cities.push(this.profile.city);
      }

      if (this.profile.birthday_on) {
        this.birthday_on = this.profile.birthday_on || null;
      }
      this.loadAddresses(this.profile.delivery_address);
    },
    profileSubmit() {
      const app = this;
      if (this.$refs.form.validate() && this.isAuthenticated) {
        const profile = {
          profile_id: app.profile.profile_id,
          birthday_on: app.birthday_on,
          address: app.profile.address,
          phone_mobile_local: app.profile.phone_mobile,
          phone_local: app.profile.phone,
          email: app.profile.email,
          photo: app.profile.photo,
          city_id: app.profile.city_id,
          social_link: app.profile.social_link,
          social_link_additional: app.profile.social_link_additional,
          size_id: app.profile.size_id,
          delivery_address: app.profile.delivery_address,
        };
        app.$store.getters.axl
          .post('profiles/api/profiles/edit', profile)
          .then(() => {
            app.$store.dispatch('ShowInfo', 'Ваш профиль был успешно обновлён');
            app.$store.dispatch('GetProfile');
            this.setDisabledFields();
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          });
      } else {
        app.$store.dispatch('HandleError', 'Ошибка отправки формы');
      }
    },
    /** Предзагрузка данных в форму если участник добавлен в админке */
    LoadPages(url, name) {
      const app = this;
      app.$store.getters.axl
        .post('/pages/api/pages', { url })
        .then((response) => {
          app.$data[name] = response.data.page;
        });
    },
    loadAddresses(val) {
      if (!val) {
        this.addresses = [];
        return;
      }
      this.$store.getters.axl.post('profiles/api/profiles/autocomplete-address', { term: val })
        .then((result) => {
          if (result.data.addresses[0]
            && result.data.addresses[0].value === this.profile.delivery_address) {
            result.data.addresses[0].unrestricted_value = this.profile.delivery_address;
          }
          this.addresses = result.data.addresses;
        });
    },
  },
  watch: {
    'password.new': (value) => {
      const passwordField = document.getElementById('password');
      const messageWrapper = passwordField.getElementsByClassName(
        'v-messages__wrapper',
      )[0];
      messageWrapper.innerHtml = '';
      messageWrapper.innerText = '';
      const checkPassword = patternPassword(value);
      const resultObject = {
        lessThen8Symbols: 'минимум 8 символов',
        noDigits: '1 цифра',
        noCapitalLetter: '1 заглавная латинская буква',
        noLowercaseLetter: '1 прописная латинская буква',
        noSpecialCharacter: '1 специальный символ',
        hasSpaces: 'без пробелов',
      };
      const div = document.createElement('div');
      const beginning = document.createElement('span');
      div.appendChild(beginning);
      Object.keys(resultObject).forEach((key) => {
        const messageDiv = document.createElement('div');
        const color = checkPassword[key] ? 'red' : 'green';
        const icon = document.createElement('i');
        icon.style.color = color;
        icon.innerHTML = checkPassword[key] ? '✗' : '✓';
        messageDiv.appendChild(icon);
        const message = document.createElement('span');
        message.innerHTML = resultObject[key];
        message.style.color = color;
        message.style.marginLeft = '5px';
        messageDiv.appendChild(message);
        div.appendChild(messageDiv);
      });
      messageWrapper.appendChild(div);
    },
    birthday_on(val) {
      if (val) {
        const date = new Date(val);
        this.birthday_on_local = date.toLocaleDateString();
      }
    },
    menu(val) {
      // eslint-disable-next-line no-return-assign
      val && setTimeout(() => (this.activePicker = 'YEAR'));
    },
    /** Вотчер для автокомплита городов */
    searchCity(val) {
      if (val) {
        this.$store.getters.axl
          .post('location/api/cities/list', { term: val })
          .then((result) => {
            this.cities = result.data.cities;
          });
      }
    },
    searchAddress(val) {
      this.loadAddresses(val);
    },
  },
  mounted() {
    if (this.isAuthenticated) {
      this.$store.dispatch('SetTitle', 'Профиль пользователя');
      this.$store.dispatch('eps/GetOrders', this.user.profile_id);
      this.createUser();
      this.setDisabledFields();
      this.LoadPages('pers', 'pers');
      this.LoadPages('rules', 'rulesHtml');
      this.$store.getters.axl
        .post('/shop/api-v3/size/list')
        .then((result) => {
          this.sizes = result.data.sizes;
        });
    }
  },
};
